import Plyr from 'plyr';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import Alpine from 'alpinejs';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

interface VideoImageSliderComponent extends InitSwiperComponent {

  initPlyrVideo(video: Element): void;
}

export default function initVideoImageSlider() {
  Alpine.data(
    'videoImageSlider',
    (): VideoImageSliderComponent => ({
      swiper: null,
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          // @ts-ignore
          const sliderSection = this.$el;

          const swiperEl = sliderSection.querySelector('.slider-video-image-swiper');
          if (swiperEl) {
            this.initSwiper(swiperEl);
          }

          if (!window.verifyCookies || window.verifyCookies()) {
            const sliderVideoComponents = sliderSection.querySelectorAll('.slider-video-component');
            sliderVideoComponents.forEach((video: HTMLIFrameElement) => {
              this.initPlyrVideo(video);
            });
          }
        });
      },
      initSwiper(domEl: HTMLElement) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .slider-video-image-next-btn`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .slider-video-image-prev-btn`,
          },
        });
      },
      initPlyrVideo(video: Element) {
        const player = new Plyr(video, {
          controls: [],
          loop: {
            active: true,
          },
          muted: true,
          autoplay: true,
          youtube: {
            noCookie: true,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
          },
        });
        player.on('ready', () => {
          setTimeout(() => {
            // @ts-ignore
            const iframes = this.$el.querySelectorAll(
              '.slider-video-image-slide__video .plyr__video-wrapper.plyr__video-embed iframe',
            );
            iframes.forEach((iframe: HTMLIFrameElement) => {
              if (iframe) {
                if (!iframe.hasAttribute('sandbox')) {
                  iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms');
                }
              }
            });
          }, 100);
        });
      },
    }),
  );
}
